import ErrorMessage from "../../shared/error/ErrorMessage";
import { EVENTS } from "../../Tracking";
import { MembershipProduct } from "../PaymentViewModel";
import MasterCardLogo from "../logos/MasterCardLogo";
import { NafCheckoutButton } from "./NafCheckoutButton";
import PaymentLogos from "./PaymentLogos";
import { ProductInfo } from "./PaymentRoutes";
import { ProductPaymentOptions } from "./PaymentStatus";
import { useMembershipPaymentClient } from "./MembershipPaymentClient";
import VisaLogo from "../logos/VisaLogo";
import VippsLogo from "../../shared/logos/VippsLogo";

export default function Product({ product }: { product: MembershipProduct }) {
  const { initiateCheckout, isLoading, isCreating, isWaitingForUrl, error } =
    useMembershipPaymentClient();

  return (
    <div>
      <ProductInfo product={product} />
      <ProductPaymentOptions>
        <NafCheckoutButton
          onClick={async () => initiateCheckout(product.id)}
          isLoading={isLoading}
          loadingText={
            isCreating ? "Oppretter" : isWaitingForUrl ? "Venter på svar" : null
          }
          trackEvent={EVENTS.PAYMENT.INITIATE_VIPPS_PAYMENT}
        />
        {error ? (
          <ErrorMessage>En feil har oppstått! Prøv igjen.</ErrorMessage>
        ) : null}
        <PaymentLogos>
          <VippsLogo />
          <VisaLogo />
          <MasterCardLogo />
        </PaymentLogos>
      </ProductPaymentOptions>
    </div>
  );
}
